<template>
  <group-details :group="group"></group-details>
</template>

<script>
import GroupDetails from "@/components/GroupDetails";
import axios from "axios";

export default {
  components: {
    GroupDetails
  },
  data: () => ({
    group: undefined
  }),
  async mounted() {
    const { data: group } = await axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}${this.$route.path}`
    });
    this.group = group;
  }
};
</script>